import {Routes} from '@angular/router';
import { StandardTestResultsMainComponent } from './standard-test-results-main.component';
import { PageTitle } from '../../core/page-title';
import { investigatorTestResultsActivityHandler } from '../../activities/navigation-activity/handlers/investigator/investigator-test-results-activity-handler';
import { navigationActivity } from '../../activities/navigation-activity/navigation-activity-resolver';
import { routeParams } from '../../shared/route-helpers';

export const standardTestResultsRoutes: Routes = [
    {
        path: 'standard-test-results',
        pathMatch: 'full',
        redirectTo: 'standard-test-results/test-results'
    },
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'standard-test-results/test-results'
    },
    {
        path: `standard-test-results/:${routeParams.tabName}`,
        data: {
            title: PageTitle.getInvestigatorTitle('Standard Test Results'),
            ...investigatorTestResultsActivityHandler()
        },
        resolve: { ...navigationActivity },
        component: StandardTestResultsMainComponent
    }
];